// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gTX_","rootMobile":"styles_rootMobile__3yUUF"};